import React, { Component } from 'react'

import Checkbox from '../form/Checkbox'

class SelfCertify extends Component {
    selfCertify = ({ value }) => {
        const { certificationStore, index } = this.props
        certificationStore.selfCertify(value, index)
    }

    render() {
        const { selfSelectQuestion } = this.props
        const { label, passed, id } = selfSelectQuestion

        return (
            <div>
                <Checkbox
                    label={label}
                    name={id}
                    checked={passed}
                    className="exploriNativeCheckbox"
                    onBlur={this.selfCertify}
                />
            </div>
        )
    }
}

export default SelfCertify
